<script>
  import Toast from "./components/Toast.svelte";

  import { dismissToast, toasts } from "./store/index";
</script>

{#if $toasts}
  <section>
    {#each $toasts as toast (toast.id)}
      <Toast
        type={toast.type}
        dismissible={toast.dismissible}
        on:dismiss={() => dismissToast(toast.id)}>{toast.message}</Toast
      >
    {/each}
  </section>
{/if}

<style>
  section {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    width: 100%;
    display: flex;
    margin-top: 110px;
    justify-content: center;
    flex-direction: column;
    z-index: 10000000000000;
    align-items: flex-end;
  }
</style>
